import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const sessionGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);

    // Check if 'session_id' is present in query parameters
    if (!route.queryParamMap.has('session_id')) {
        // Redirect to sign-in page if session_id is missing
        return router.navigate(['sign-in']); // Use navigate for redirection
    }

    // Allow activation if session_id is present
    return true;
};
